const networkConfig = {
  apiKey: process.env.REACT_APP_MYHEALTH_GATEWAY_API_TOKEN,
};
export default networkConfig;
